import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import './RatingComponent.scss';

export default class RatingComponent5 extends Component {
    static get propTypes() {
        return {
            minLabel: PropTypes.string,
            maxLabel: PropTypes.string,
            onChange: PropTypes.func,
            activeRange: PropTypes.number
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            activeRange: props.activeRange
        };
    }

    onChangeRange(event) {
        this.setState({activeRange: event.target.value});
        this.props.onChange && this.props.onChange(event.target.value);
    }

    render() {
        const {minLabel, maxLabel} = this.props;
        const activeRange = this.state.activeRange;

        return (
            <div className="rating-component">
                <div key="slider">
                    <div className="tickmarks5">
                        {[1, 2, 3, 4, 5].map(mark => {
                            return <span key={mark} className={activeRange == mark ? 'active' : ''}>{mark}</span>;
                        })}
                    </div>
                    <input
                        ref={el => this.el = el}
                        type="range"
                        min={1}
                        max={5}
                        step={1}
                        readOnly={false}
                        value={activeRange}
                        onChange={e => this.onChangeRange(e)}
                    />
                    <div className="points5">
                        {[1, 2, 3, 4, 5].map(mark => {
                            return <div key={mark} className="point5"><span className="round"/></div>;
                        })}
                    </div>
                </div>
                <div className="labels">
                    <div className="min-label">{minLabel}</div>
                    <div className="max-label">{maxLabel}</div>
                </div>
            </div>
        );
    }
}
